import { createFileRoute } from "@tanstack/react-router";
import { SkillsAdminPage } from "@/shared/ui/SkillsAdminPage";

export const Route = createFileRoute("/_app/skills")({
  component: SkillsAdminPage,
});
